import { render, staticRenderFns } from "./Address.pc.vue?vue&type=template&id=cba0a83c&scoped=true&"
import script from "./Address.pc.vue?vue&type=script&lang=js&"
export * from "./Address.pc.vue?vue&type=script&lang=js&"
import style0 from "./Address.pc.vue?vue&type=style&index=0&id=cba0a83c&lang=scss&scoped=true&"
import style1 from "./Address.pc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0a83c",
  null
  
)

export default component.exports